// Client-side redirect map for legacy Wix-era URLs and common aliases.
// React Router does the redirects at runtime; the sitemap and Google will
// eventually pick up the new canonical URLs.
export const REDIRECTS = {
  // Portfolio family
  "/work": "/portfolio",
  "/work/": "/portfolio",
  "/portfolio-old": "/portfolio",
  "/projects": "/portfolio",
  "/case-studies": "/portfolio",
  // Portfolio: anonymized project slugs (previous brand-named URLs -> new generic slugs)
  "/portfolio/bristol-auto-performance": "/portfolio/multi-service-auto-shop",
  "/portfolio/agent-marketing": "/portfolio/real-estate-marketing-subbrand",
  "/portfolio/murray-mortgages": "/portfolio/independent-mortgage-broker",
  "/portfolio/deanos-chicken": "/portfolio/local-restaurant-social",
  "/portfolio/wings-n-things-chip-stand": "/portfolio/seasonal-food-stand-brand",
  "/portfolio/talentroute": "/portfolio/talent-and-recruitment-brand",
  "/portfolio/openline": "/portfolio/ai-receptionist-brand",
  "/portfolio/fixbook": "/portfolio/home-services-booking-brand",
  "/portfolio/lotwise-auto": "/portfolio/dealership-support-brand",
  "/portfolio/fundroute": "/portfolio/capital-access-brand",
  "/portfolio/operating-class": "/portfolio/operator-media-brand",
  "/portfolio/refreshers-ottawa": "/portfolio/local-detailing-brand",
  // Blog family
  "/insights": "/blog",
  "/insights/": "/blog",
  "/articles": "/blog",
  "/news": "/blog",
  "/resources": "/blog",
  // Services family
  "/services-old": "/services",
  "/what-we-do": "/services",
  "/marketing-services": "/services",
  "/website-design": "/services/website-design",
  "/branding": "/services/brand-strategy",
  "/social-media": "/services/social-media-marketing",
  "/google-business-profile": "/services/google-business-profile-local-seo",
  "/local-seo": "/services/google-business-profile-local-seo",
  // Contact family
  "/contact-us": "/contact",
  "/get-in-touch": "/contact",
  "/start": "/contact",
  "/inquire": "/contact",
  // Book family
  "/book-call": "/book",
  "/book-a-call": "/book",
  "/strategy-call": "/book",
  "/schedule": "/book",
  // Shop family
  "/store": "/shop",
  "/resources-shop": "/shop",
  "/digital-resources": "/shop",
  // Podcasts family
  "/radio-kostaja": "/podcasts",
  "/podcast": "/podcasts",
  // Service areas
  "/service-area": "/service-areas",
  "/locations": "/service-areas",
  // Legal (flat -> /legal/:slug)
  "/privacy": "/legal/privacy",
  "/terms": "/legal/terms",
  "/refund-policy": "/legal/refund-policy",
  "/accessibility": "/legal/accessibility",
};
